var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.668 2H5.66797C4.01111 2 2.66797 3.34315 2.66797 5V15C2.66797 16.6569 4.01111 18 5.66797 18H11.2538L7.96086 21.2929C7.57034 21.6834 7.57034 22.3166 7.96086 22.7071C8.35139 23.0976 8.98455 23.0976 9.37508 22.7071L12.668 19.4142L15.9609 22.7071C16.3514 23.0976 16.9846 23.0976 17.3751 22.7071C17.7656 22.3166 17.7656 21.6834 17.3751 21.2929L14.0822 18H19.668C21.3248 18 22.668 16.6569 22.668 15V5C22.668 3.34315 21.3248 2 19.668 2ZM5.96086 14.3739C5.57034 13.9833 5.57034 13.3502 5.96086 12.9597L9.96086 8.95965C10.3239 8.59662 10.9029 8.56748 11.3005 8.89223L12.5743 9.93253L15.9358 6.31899C16.1245 6.11611 16.3889 6.00063 16.666 6.00009C16.9431 5.99956 17.208 6.11401 17.3975 6.31615L19.3975 8.44948C19.7752 8.8524 19.7548 9.48523 19.3519 9.86296C18.949 10.2407 18.3162 10.2203 17.9384 9.81737L16.6708 8.46524L13.4002 11.9812C13.041 12.3673 12.4438 12.4081 12.0354 12.0746L10.7357 11.0132L7.37508 14.3739C6.98455 14.7644 6.35139 14.7644 5.96086 14.3739Z",
    fill: "#F3A218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChart);
export default __webpack_public_path__ + "static/media/ic_chart.346ac81bb3db1d0c96c40cb8ab984c30.svg";
export { ForwardRef as ReactComponent };